import { render, staticRenderFns } from "./FileDownloadAccess.vue?vue&type=template&id=2fcc323e&scoped=true&"
import script from "./FileDownloadAccess.vue?vue&type=script&lang=js&"
export * from "./FileDownloadAccess.vue?vue&type=script&lang=js&"
import style0 from "./FileDownloadAccess.vue?vue&type=style&index=0&id=2fcc323e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc323e",
  null
  
)

export default component.exports